import React from "react";

// Import puppelshow logo
let puppelLogo;
try {
  puppelLogo = require("../images/puppelshow/puppel-left.png");
} catch (e) {
  puppelLogo = null;
}

const PuppelshowSection = () => {
  const videoEmbedUrl = "https://www.youtube.com/embed/UY85CZWobfc";

  return (
    <section id="puppel-show" className="section puppelshow">
      <h2 className="section__title">Puppel Show</h2>

      <div className="puppelshow__grid">
        {/* Left — Logo + Press Kit */}
        <div className="puppelshow__left">
          {puppelLogo && (
            <img
              src={puppelLogo}
              alt="Puppel Show Logo"
              className="puppelshow__logo"
            />
          )}
          <a href="/presskit" className="puppelshow__presskit-btn">
            Press Kit
          </a>
        </div>

        {/* Right — Video + Description */}
        <div className="puppelshow__right">
          <div className="puppelshow__video-wrapper">
            <iframe
              src={videoEmbedUrl}
              title="Puppel Show Trailer"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <p className="puppelshow__description">
            We are a passionate game studio dedicated to creating unique and
            enjoyable experiences for players around the world.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PuppelshowSection;
